import React from 'react';
import {
  Grid,
  Typography,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  Button,
  Link,
  Divider,
} from '@mui/material';
import { Circle } from '@mui/icons-material';

const ButtonLink = ({ href, label }) => (
  <Button
    size="small"
    variant="text"
    color="primary"
    href={href}
    target="_blank"
    rel="noopener"
  >
    {label}
  </Button>
);

export default function ELFLanding() {
  return (
    <Grid container>
      <Grid item xs={12} textAlign="center" padding>
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
          ELF (Educational Loan Fund)
        </Typography>
      </Grid>
      <Grid item xs={2} />
      <Grid item xs={8} textAlign="center">
        <Typography variant="body1" sx={{ fontStyle: 'italic' }}>
          The P.E.O. Educational Loan Fund makes loans available to qualified
          women who desire a higher education and are in need of financial
          assistance. All applicants are recommended by a local P.E.O. chapter.
        </Typography>
      </Grid>
      <Grid item xs={2} />

      <Grid item xs={12} padding>
        <Card
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            overflow: 'auto',
          }}
        >
          <CardHeader
            title="Local Chapter Recommendation Process"
            subheader="Use the resources below to help you identify, interview and recommend your chapter ELF candidate. Recommendations can be submitted year round."
          />
          <CardContent>
            <Grid container xs={12}>
              <Grid item xs={6}>
                <Typography
                  variant="body1"
                  padding
                  sx={{ fontWeight: 'bold', backgroundColor: 'lightblue' }}
                >
                  Step
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  variant="body1"
                  padding
                  sx={{ fontWeight: 'bold', backgroundColor: 'lightblue' }}
                >
                  Resources
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1" padding>
                  1. Review the ELF Policies and Chapter Procedure for
                  Sponsoring an Applicant.
                </Typography>
              </Grid>
              <Grid item container xs={6} spacing={1}>
                <Grid item xs={12}>
                  <ButtonLink
                    href="https://www.peointernational.org/wp-content/uploads/2024/05/ELF-Policies-Governing-Loans-072024-1.pdf"
                    label="ELF Policies Governing Loans"
                  />
                </Grid>
                <Grid item xs={12}>
                  <ButtonLink
                    href="https://www.peointernational.org/wp-content/uploads/2023/11/ELF-Chapter-Procedure-for-Sponsoring-an-Applicant-072024.pdf"
                    label="Chapter Procedure for Sponsoring an Applicant"
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} padding>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1" padding>
                  2. Review the Summary of Interview and Recommendation of an
                  ELF Applicant document, then interview your candidate.
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2023/11/ELF-Summary-of-Interview-and-Recommendation-of-an-Applicant-0724.pdf"
                  label="Summary of Interview and Recommendation of an Applicant"
                />
              </Grid>
              <Grid item xs={12} padding>
                <Divider />
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1" padding>
                  3. After a successful chapter vote, including the recommended
                  loan amount, complete the online ELF Recommendation Form.
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2025/05/Chapter-Form-Instructions-all-projects-08.18.25.pdf"
                  label="Instructions for the online Recommendation Form"
                />
              </Grid>
            </Grid>
            <Grid item xs={12} padding>
              <Divider />
            </Grid>
            <Grid item xs={6}>
              <Typography variant="body1" padding>
                4. Approximately two weeks after your submission, please confirm
                your applicant has received her application link. Contact
                elf@peodsm.org if she has not received the link.
              </Typography>
            </Grid>
            <Grid item xs={6} />
            <Grid item xs={12} padding textAlign="center">
              <Typography variant="caption" sx={{ fontWeight: 'bold' }}>
                Both the chapter and student will be notified of the decision.
                If the decision is favorable, due to privacy concerns, the
                chapter will not be notified of the amount of the approved loan.
              </Typography>
            </Grid>
          </CardContent>
          <CardActions>
            <Grid container xs={12} paddingBottom={2}>
              <Grid item xs={12} textAlign="center" padding>
                <Link
                  href="https://peointernational.communityforce.com/Funds/FundDetails.aspx?496F49596D593768464E3537506B6F754D5442315A38312B6676597151394F536376726B7A70417256394477734277704B49706D5252624A57594D375A615A777648646D7043424375436B3D"
                  target="_blank"
                  rel="noopener"
                >
                  <Button variant="contained" color="primary">
                    Access ELF Recommendation Form
                  </Button>
                </Link>
              </Grid>
              <Grid item xs={2} />
              <Grid item xs={8} textAlign="center">
                <Typography variant="caption">
                  Click the button above to be directed to the CommunityForce
                  application system. CommunityForce is a third party vendor we
                  utilize for managing applications. Separate login credentials
                  will be required.
                </Typography>
              </Grid>
              <Grid item xs={2} />
            </Grid>
          </CardActions>
        </Card>
      </Grid>
      <Grid item xs={12} padding>
        <Card
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            overflow: 'auto',
          }}
        >
          <CardHeader
            title="Eligibility Requirements"
            sx={{ pb: 0 }}
            subheader="A woman is eligible for consideration for an ELF loan if she:"
          />
          <CardContent>
            <Grid container xs={12}>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  <Circle sx={{ fontSize: 10, pr: 2 }} />
                  Is recommended by a local chapter of the P.E.O. Sisterhood
                  with a favorable vote on the amount of the loan
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  <Circle sx={{ fontSize: 10, pr: 2 }} />
                  Is a citizen or legal permanent resident of and resides in the
                  United States or Canada
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  <Circle sx={{ fontSize: 10, pr: 2 }} />
                  Submits an application within six to 24 months prior to the
                  stated graduation or course completion date
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" padding>
                <Circle sx={{ fontSize: 10, pr: 2 }} />
                Has been accepted by or is enrolled full- or part-time in an
                accredited U.S. or Canadian post-secondary institution
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1" padding>
                <Circle sx={{ fontSize: 10, pr: 2 }} />
                Has a high school diploma or the equivalent
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body1" padding>
                <Circle sx={{ fontSize: 10, pr: 2 }} />
                Demonstrates the academic ability to remain “in good standing”
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body1" padding>
                <Circle sx={{ fontSize: 10, pr: 2 }} />
                Meets the minimum credit score of 625
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body1" padding>
                <Circle sx={{ fontSize: 10, pr: 2 }} />
                Does not exceed the indebtedness limit for the degree level
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body1" padding>
                <Circle sx={{ fontSize: 10, pr: 2 }} />
                Has a qualified cosigner for the loan
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body1" padding>
                <Circle sx={{ fontSize: 10, pr: 2 }} />
                Does not have an outstanding ELF loan
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body1" padding>
                <Circle sx={{ fontSize: 10, pr: 2 }} />
                Demonstrates financial need
              </Typography>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={6} padding>
        <Card
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            overflow: 'auto',
          }}
        >
          <CardHeader title="Maximum Loan Amounts" sx={{ pb: 0 }} />
          <CardContent>
            <Grid container xs={12}>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  <Circle sx={{ fontSize: 10, pr: 2 }} />
                  $12,000 for an accredited non-degree or associate degree
                  program
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  <Circle sx={{ fontSize: 10, pr: 2 }} />
                  $15,000 for bachelor's degree programs
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  <Circle sx={{ fontSize: 10, pr: 2 }} />
                  $20,000 for master's degree programs
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  <Circle sx={{ fontSize: 10, pr: 2 }} />
                  $25,000 for doctoral degree programs
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={6} padding>
        <Card
          sx={{
            boxShadow: 3,
            borderRadius: 2,
            overflow: 'auto',
          }}
        >
          <CardHeader title="Application Process" sx={{ pb: 0 }} />
          <CardContent>
            <Grid container xs={12}>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  <Circle sx={{ fontSize: 10, pr: 2 }} />
                  Members of a local P.E.O. chapter will interview a student
                  before deciding to recommend her.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  <Circle sx={{ fontSize: 10, pr: 2 }} />
                  The chapter will vote to recommend a student and complete a
                  recommendation form.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  <Circle sx={{ fontSize: 10, pr: 2 }} />
                  P.E.O. Executive Office will send her a link to an online
                  application, which she has 30 days to complete.
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1" padding>
                  <Circle sx={{ fontSize: 10, pr: 2 }} />
                  The Educational Loan Fund trustees then review the
                  application. The average processing time is eight to 12 weeks,
                  provided all requirements are promptly met.
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
